// extracted by mini-css-extract-plugin
export default {"glassButton":"ScrollButton_glassButton__oXcWl","shimmer":"ScrollButton_shimmer__XJR+h","clicked":"ScrollButton_clicked__EGmAX","openRipple":"ScrollButton_openRipple__m5+dt"};